module.exports = __webpack_public_path__ + "img/Aff&aumlrsidé.d9cff254.jpg";